import React, { useEffect, useState, useCallback } from "react";
import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import PageHeader from "../PageHeader";
import { PageHeaderName } from "../../StyledCss/styledComponents";
import "./index.css";
import LoadingView from "../LoadingView";
import FailureView from "../FailureView";
import {
  getProjectDetails,
  addProject
} from "../../api/services/hroneApi";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { convertKeysToSnakeCase } from "../../util/convertToSnakeCase";
import { ProjectDetailsCard } from "./ProjectDetails";
import { EmployeeTable } from "./EmployeesTable";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import toast from "react-hot-toast";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const ProjectUserAssociation = () => {
  const { hasPermission } = usePermissions();
  const canViewProject = hasPermission(FEATURE_CODES.PROJECT_VIEW);
  const navigate = useNavigate();
  const handleProjectClick = () => {
    navigate(-1);
  };
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [usersData, setUsersData] = useState([]);
  const [cloneData, setCloneData] = useState({});
  const [timeLine, setTimeLine] = useState([]);

  const { id } = useParams();
  const [loadingStates, setLoadingStates] = useState({
    addProject: false
  });
  const [errorMessages, setErrorMessages] = useState({
    addProject: ""
  });

  const setLoading = (operation, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [operation]: isLoading }));
  };
  const getProjectDetailsList  = useCallback(async () => {
    try {
      setApiStatus(apiStatusConstants.inProgress);

      const response = await getProjectDetails(id);

      if (response.ok) {
        setApiStatus(apiStatusConstants.success);

        const data = convertKeysToCamelCase(await response.json());
        setUsersData(data);
        setTimeLine(data?.history?.timeline);
        const { id, employeeCount, startDate, status, employees, history, ...clonePayload } = data;
        setCloneData(clonePayload);

      }
    } catch (error) {
      setApiStatus(apiStatusConstants.failure);

      console.error("Error fetching users:", error);
    }
  }, [id]);

  useEffect(() => {
    getProjectDetailsList();
  }, [getProjectDetailsList]);

  useEffect(() => {
    if (!canViewProject) {
      navigate(-1);
    }
  }, [canViewProject, navigate]);

  const onClickRetry = () => {
    getProjectDetailsList();
  };

  const handleUserDataChange = (userData) => {
    setUsersData(userData);
    setTimeLine(userData?.history?.timeline);
  };

  const handleCloneProject = 
    async (newProject) => {
      try {
        setLoading("addProject", true);

        const payload = { ...newProject, clone: true };
        const response = await addProject(convertKeysToSnakeCase(payload));
        if (response.ok) {
          toast.success("Project Added Successfully");
          await getProjectDetailsList();

        } else {
          const data = await response.json();
          setErrorMessages((prev) => ({ ...prev, addProject: data.detail }));
        }
      } catch (error) {
        toast.error("Failed to update project");
      } finally {
        setLoading("addProject", false);
      }
    }
  

  const renderContent = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      case apiStatusConstants.success:
        return (
          <>
            <ProjectDetailsCard 
              project={usersData}
              cloneDefaultValues={cloneData}
              timeline={timeLine} 
              onCloneProject={handleCloneProject}
              isUpdating={loadingStates.addProject}
              errorMsg={errorMessages.addProject}
            />
            <EmployeeTable
              employees={usersData.employees}
              status={usersData.status}
              projectId={id}
              startDate={usersData.startDate}
              onDataRefresh={handleUserDataChange}
            />
          </>
        );
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      default:
        return null;
    }
  };

  if (!canViewProject) {
    return null;
  }

  return (
    <div>

      <Header />
      <div className="d-flex ">
        <LeftNavBar />
        <div className="page-content-wrapper">
          <PageHeader>
            <PageHeaderName>
              <ArrowLeft size={20}
              onClick={() => handleProjectClick()}
              style={{ cursor: "pointer" }} /> Project Details
            </PageHeaderName>
          </PageHeader>
          <div className="table-container">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default ProjectUserAssociation;
